import React, { useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { analySend, getInfo } from '@chat/utils';
import { ProAdMsgCollapse } from '@chat/components';
import { getresolve } from '@/redux/faq/action';
import useObjectState from '@/hooks/useObjectState';
import { MyThunkResult } from '@/typings/reducer';
import { IM_CTX, IM_MESSAGE } from '@/typings/global';
import { outline } from '@/helpers/online';
import { GM_AVATAR, GM_NICK } from '@/helpers/userInfo';
import MsgActions from '@/components/MessageList/MsgActions';
import Reason from './Reason';

function index(props: IM_MESSAGE): JSX.Element {
    const { ctx, id, msg_type } = props;
    const resolove_ctx = ctx as IM_CTX;
    const { u, v } = getInfo();
    const { support_msg_collapse } = IM.SDKServer.getState();
    const dispatch: MyThunkResult<Promise<any>, any> = useDispatch();
    const { can_faq, platform, game_key, game_name, faq_unique_id, request_type } = useSelector(
        ({ FaqReducer, IndexReducer }) => ({
            can_faq: FaqReducer.can_faq,
            request_type: FaqReducer.request_type,
            platform: IndexReducer.base_config.game.platform,
            game_key: IndexReducer.base_config.game.key,
            game_name: IndexReducer.base_config.game.name,
            faq_unique_id: IndexReducer.base_config.faq_unique_id
        }),
        shallowEqual
    );
    const { objState: status, handleObjState: setStatus } = useObjectState({
        initialValue: {
            resolve: false,
            unresolve: false
        }
    });
    const [show, setShow] = useState(false);
    // 是否被点击
    const isClick = status.resolve || status.unresolve;
    // 禁用相关样式
    const _handleIcon = (name: string): string => {
        if (!can_faq || (can_faq && isClick)) {
            return `ic-${name}-clicked`;
        }
        return `ic-${name}`;
    };
    // 按钮能否被点击
    const _handleShouldClick = (name: string): string => {
        return classnames(`btn-${name}`, {
            'disable-resolve-btn': !can_faq || isClick,
            cur: status[name],
            siblings: !status[name]
        });
    };
    const _handleResolve = async (name, solve) => {
        if (outline()) return;
        setStatus(name, true);
        try {
            await dispatch(
                getresolve({
                    solve,
                    log_id: resolove_ctx.log_id,
                    faq_id: resolove_ctx.id,
                    dify: resolove_ctx.dify
                })
            );
            if (solve === 0) {
                setShow(true);
                IM.scrollToEnd();
            }
        } catch (error) {
            setStatus(name, false);
        } finally {
            analySend('element_click', {
                page_name: '咨询页',
                element_name: name === 'unresolve' ? '未解决' : '已解决',
                project_id: platform,
                game_key,
                game_name,
                uid: u,
                vid: v,
                ai_session_id: faq_unique_id,
                ai_message_id: id,
                session_type: request_type,
                answer_source: resolove_ctx.dify === 1 ? 'AI' : '关键词匹配'
            });
        }
    };
    return (
        <li className="im-message-in">
            {GM_AVATAR('faq', 'faq')}
            <div className="im-message-block">
                {GM_NICK('faq', 'faq')}
                <div className="im-message-content" onClick={IM.SDKServer.DomClick}>
                    <div className="im-faq-title">{resolove_ctx.title}</div>
                    {support_msg_collapse && (
                        <ProAdMsgCollapse enabled recomputeKey={`${id}-${msg_type}`}>
                            <div dangerouslySetInnerHTML={{ __html: resolove_ctx.answer }} />
                        </ProAdMsgCollapse>
                    )}
                    {!support_msg_collapse && (
                        <div dangerouslySetInnerHTML={{ __html: resolove_ctx.answer }} />
                    )}
                    <div
                        className={classnames('im-faq-btn', {
                            'disable-resolve': isClick || !can_faq
                        })}
                    >
                        <button
                            className={_handleShouldClick('unresolve')}
                            onClick={() => _handleResolve('unresolve', 0)}
                        >
                            <i className={_handleIcon('unresolve')} />
                            <span>未解决</span>
                        </button>
                        <button
                            className={_handleShouldClick('resolve')}
                            onClick={() => _handleResolve('resolve', 1)}
                        >
                            <i className={_handleIcon('resolve')} />
                            <span>已解决</span>
                        </button>
                    </div>
                    {show && <Reason ctx={resolove_ctx} id={id} />}
                </div>
                {resolove_ctx.dify === 1 && (
                    <div className="im-message-ai-indicator">此消息由AI生成</div>
                )}
                <MsgActions item={props} />
            </div>
        </li>
    );
}

export default index;
